import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from 'components/BaseComponent';
import OrgFormModal from './OrgFormModal';
import Search from 'components/Search';
import $$ from 'cmn-utils';
import config from '@/config';
import { Tree, Spin, Tooltip, Modal, Row, Col } from 'antd';
import Button from 'components/Button';
import classNames from 'classnames';
import { deepClone } from '@/utils/common';
import './style/index.less';
import {
  qryOrgList,
  addOrg,
  delOrg,
  updateOrg,
} from '../service';

const notice = config.notice;

function noop() { }

export default class OrgTree extends BaseComponent {
  static defaultProps = {
    title: window.language['org.title'],
    prefixCls: 'antui-orgtree-list',
    checkable: false,//是否展示checkbox框
    multiple: false,//是否支持多选select
    cascadable: false,//是否可级联选择子节点
    selectSyncToCheck: false,//是否需要将节点select事件同步到节点check事件，主要是调用onChecked方法中的onChange事件
    disableCheckRoot: true,//根节点是否可以check
    disableRoot: false,//根节点是否不可用
    onChange: noop,
    onSearch: noop,//查询加载完数据后回调函数
    treeKey: 'key',
    treeTitleKey: 'title',
    treeLevelKey: 'level',
    checkedKeys: [],
    selectedKeys: [],
    showSearch: false,//是否展示搜索框
    showToolbar: false,//是否展示顶部工具条
    expandAll: true,//是否展示所有树节点
    canSelectOperaterOrg: true,//能否选择当前登录用户的机构
    footer: noop,
    loading: true,
    callback: noop,
    qrySimpleOrg: false,//是否查询简易的机构实例（返回数据只包含ID和Name，加快响应速度）
  };

  static propTypes = {
    title: PropTypes.string,
    prefixCls: PropTypes.string,
    checkable: PropTypes.bool,
    multiple: PropTypes.bool,
    cascadable: PropTypes.bool,
    selectSyncToCheck: PropTypes.bool,
    disableCheckRoot: PropTypes.bool,
    disableRoot: PropTypes.bool,
    onChange: PropTypes.func,
    onSearch: PropTypes.func,//查询加载完数据后回调函数
    listStyle: PropTypes.object,
    listRender: PropTypes.func,
    treeKey: PropTypes.string,
    treeTitleKey: PropTypes.string,
    treeLevelKey: PropTypes.string,
    checkedKeys: PropTypes.array,
    selectedKeys: PropTypes.array,
    className: PropTypes.string,
    showSearch: PropTypes.bool,
    showToolbar: PropTypes.bool,
    expandAll: PropTypes.bool,
    canSelectOperaterOrg: PropTypes.bool,
    searchPlaceholder: PropTypes.string,
    notFoundContent: PropTypes.node,
    footer: PropTypes.func,
    treeRender: PropTypes.func,
    loadData: PropTypes.func,
    loading: PropTypes.bool,
    asyncSearch: PropTypes.func,
    callback: PropTypes.func,
    qrySimpleOrg: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = {
      formModalVisible: false,
      canEditOrg: false,//是否可以编辑组织机构
      canAddOrg: false,//是否可以新增组织机构
      canDelOrg: false,//是否可以删除组织机构
      filter: '',
      searchList: [],
      nodeMap: new Map(),
      sourceNodes: [],
      checkedKeys: this.props.checkedKeys,//已勾选节点key数组
      selfRecord: null,
      parentRecord: null,
      defaultExpandedKeys: [],//默认展开的节点数组
      selectedNodes: [],//已点选节点数组
      selectedKeys: this.props.selectedKeys,//已点选节点key数组
      selectedParentNodes: [],//已点选节点对应的父节点数组（和selectedNodes是一一对应的），用户节点编辑
      authCodes: $$.getStore('authCodes'),//按钮权限代码列表
      flag: true,
      defaultExpandAll: this.props.expandAll,//默认是否展示所有树节点
    };
  }

  /**
   * 构造查找源列表
   * @param {treeData} tree数据 
   */
  getFlatTreeData(treeData) {
    let data = [];

    treeData.forEach(item => {
      if (item.children) {
        data = data.concat(this.getFlatTreeData(item.children));
      }

      data.push(item);
    });

    return data;
  }

  /**
   * 将分散的node，拼装成树
   * @param {nodeList} 分散的节点列表
   */
  createTreeNodes(nodeList) {
    //未选中任何树节点
    if (!nodeList || nodeList.length === 0) {
      return [];
    }

    /**
     * 定义“数组-链表”，该数组链表的每一项相当于一深度为2的小树
     * Map的key相当于“数组”的某一项，Map的value相当于该key所拥有的“链表”
     * 这里，key为父节点ID，list为具有相同父节点ID的所有同级子节点实体list（属于该父节点的所有子节点）
     */
    let tempMap = new Map();

    nodeList.map(item => {
      //pid对应子节点数组还未放到map中
      if (!tempMap.get(item.pid)) {
        let tempList = [];
        tempList.push(item);
        tempMap.set(item.pid, tempList);

      } else {
        let tempList = tempMap.get(item.pid);
        tempList.push(item);
      }
    });
    // 以上，至此，第一遍遍历完毕，非叶子节点都拥有一个“数组-链表项”，也即“最小的树”已创建完毕

    // 以下，对“数组链表”Map进行遍历，更改“最小的树”的从属关系（更改指针指向），也即把所有小树组装成大树
    tempMap.forEach((value, key, map) => {
      let tempList = value;

      tempList.map(item => {
        let findList = tempMap.get(item.key);
        if (findList) item.children = findList;
      });
    });

    //获取当前登录用户所属机构的PID
    const operaterOrgPid = $$.getStore("user").org.pid;

    //返回整棵树，pid为当前登录用户所属机构的PID的节点为整棵树的根节点
    return tempMap.get(operaterOrgPid);
  }

  doSearch = () => {
    let { title, treeKey, treeTitleKey, treeLevelKey, showSearch, canSelectOperaterOrg, disableCheckRoot, disableRoot } = this.props;

    //默认查询方法
    let postParams = {
      qrySimpleOrg: this.props.qrySimpleOrg
    };

    qryOrgList(postParams).then(
      ({ code, msg, root: orgList, totalNum }) => {
        if (this._isMounted) {
          if (code === "200") {
            //获取当前登录用户所属机构的PID
            const operaterOrgId = $$.getStore("user").org.id;
  
            //树节点集合
            let nodeList = new Array();
            let nodeMap = new Map();
  
            //遍历所有的组织机构
            orgList.map(item => {
              let node = {};
              node[treeKey] = item.id;
              node[treeTitleKey] = item.name;
              node["pid"] = item.pid;
              node["remark"] = item.remark;
              node[treeLevelKey] = item.level;
              node["onlineClientCount"] = item.onlineClientCount;
              node["totalClientCount"] = item.totalClientCount;
  
              //不能选择当前登录用户的机构
              if (!canSelectOperaterOrg && operaterOrgId === item.id) {
                node["disabled"] = true;
              }
  
              nodeList.push(node);
              nodeMap.set(node[treeKey], node);
            });
  
            let _tempSourceNodes = this.createTreeNodes(nodeList);
  
            this.setState({
              nodeMap,
              sourceNodes: _tempSourceNodes
            }, () => {
              //用于搜索的集合
              if (showSearch) {
                this.flatTreeData = this.getFlatTreeData(this.state.sourceNodes);
              }
  
              this.props.onSearch && this.props.onSearch(orgList, this.state.sourceNodes);
            });
          } else {
            notice.error(window.language['responseCode.' + code]);
          }
        }
      }
    ).catch((error) => {
      notice.error(window.language['conmmon.search.error']);
    });
  }

  /**
   * 当组件要从界面上装载渲染的时候，就会调用 componentWillMount()，
   * 执行一次，在初始化render之前执行，
   * 如果在这个方法内调用setState，render()知道state发生变化，并且只执行一次
   */
  componentWillMount() {
    this._isMounted = true;

    this.doSearch();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * 当props发生变化时执行，初始化render时不执行，
   * 在这个回调函数里面，你可以根据属性的变化，通过调用this.setState()来更新你的组件状态，
   * 旧的属性还是可以通过this.props来获取,这里调用更新状态是安全的，并不会触发额外的render调用
   * 
   * @param {nextProps} nextProps 新的属性对象
   */
  componentWillReceiveProps(nextProps) {
    const { checkedKeys, selectedKeys } = nextProps;

    if (nextProps.checkedKeys !== this.props.checkedKeys) {
      if (checkedKeys) {
        this.setState({
          checkedKeys: checkedKeys
        });
      }
    }

    if (nextProps.selectedKeys !== this.props.selectedKeys) {
      if (selectedKeys) {
        this.setState({
          selectedKeys: selectedKeys
        });
      }
    }
  }

  componentDidUpdate() {
    var elements = document.getElementsByClassName("ant-tree-node-selected");
    elements.length > 0 && elements[elements.length - 1].scrollIntoView(false);
  }

  /**
   * 查找事件
   */
  handleFilter = (v) => {
    this.renderFilterResult(v);

    this.setState({
      filter: v
    });
  };

  /**
   * 清除查找事件
   */
  handleClear = () => {
    this.renderFilterResult('');

    this.setState({
      filter: ''
    });
  };

  /**
   * 搜索过滤方法
   */
  renderFilterResult = filter => {
    const { treeTitleKey, asyncSearch } = this.props;
    //是否异步搜索，搜索的数据源不在本次tree中，而是在服务器接口查找
    if (asyncSearch) {
      const promise = asyncSearch(filter);
      if (promise.then) {
        promise.then(listItem => {
          this.setState({
            searchList: listItem
          });
        });
      }
    } else {
      this.setState({
        searchList: this.flatTreeData.filter(
          item => item[treeTitleKey].indexOf(filter) >= 0
        )
      });
    }
  };

  forEachChildList = (childList, tempMap) => {
    childList.map(item => {
      tempMap.set(item.key, item);

      //遍历子节点
      item.children && this.forEachChildList(item.children, tempMap);
    });
  }

  findAndAddParentNode = (item, sourceNodeMap, treeNodeMap) => {
    if (!sourceNodeMap.get(item.pid)) return;

    //对象需要克隆一下才能用，如果直接用对象引用，会在后面 createTreeNodes 组树修改出问题。
    let parentNode = (origin => {
      if (!origin) return null;

      return deepClone(origin);
    })(sourceNodeMap.get(item.pid));

    if (!treeNodeMap.get(parentNode.key)) {
      treeNodeMap.set(parentNode.key, parentNode);
    }

    this.findAndAddParentNode(parentNode, sourceNodeMap, treeNodeMap);
  }

  findAndAddChildNode = (item, sourceNodeMap, treeNodeMap) => {
    if (!item.children) return;

    //遍历子节点
    item.children.map(child => {
      //对象需要克隆一下才能用，如果直接用对象引用，会在后面 createTreeNodes 组树修改出问题。
      let childNode = (origin => {
        if (!origin) return null;

        return deepClone(origin);
      })(sourceNodeMap.get(child.key));

      if (!treeNodeMap.get(childNode.key)) {
        treeNodeMap.set(childNode.key, childNode);
      }

      this.findAndAddChildNode(childNode, sourceNodeMap, treeNodeMap);
    });
  }

  findAndRemoveChildNode = (item, sourceNodeMap, treeNodeMap) => {
    if (!item.children) return;

    //遍历子节点
    item.children.map(child => {
      //对象需要克隆一下才能用，如果直接用对象引用，会在后面 createTreeNodes 组树修改出问题。
      let childNode = (origin => {
        if (!origin) return null;

        return deepClone(origin);
      })(sourceNodeMap.get(child.key));

      if (treeNodeMap.get(childNode.key)) {
        treeNodeMap.delete(childNode.key);
      }

      this.findAndRemoveChildNode(childNode, sourceNodeMap, treeNodeMap);
    });
  }

  /**
   * 勾选节点事件监听
   */
  onCheck = (_checkedKeys, info) => {
    this.onChecked(info.checked, info.checkedNodes, info.node);
    this.onTreeSelected(info.checkedNodes);
  }

  /**
   * 选择节点
   */
  onChecked = (_checked, _checkedNodes, _node) => {
    const { treeKey, treeTitleKey, treeLevelKey, cascadable } = this.props;

    let targetNodes = _checkedNodes.map(node => ({
      [treeKey]: node[treeKey],
      [treeTitleKey]: node[treeTitleKey],
      [treeLevelKey]: node[treeLevelKey],
      ...node.props
    }));

    const { nodeMap } = this.state;

    /**
     * 坑人的antd，不提供选择节点自动勾选其下所有子节点，和勾选节点自动勾选其所有上层父节点直到根节点功能
     *            不提供取消选择节点自动取消勾选其下所有子节点
     * 没有EXTJS好用啊。。。
     * 
     * 遍历左边源列表 checked 节点数据，需要将节点找出其每上层的所有上级节点，并且其每下层的所有下级节点展示出来
     * 
     * 第一步，取出checked 节点数据，封装成Map
     * 
     * 第二步，如果当前节点是选中状态则找出当前checked节点，其每上层的所有上级节点，和其每下层的所有下级节点
     *        如果当前节点是取消选中状态则取消勾选其下所有子节点
     * 
     */

    //第一步，checked 节点数据都是分散的node，不需要遍历子节点
    let treeNodeMap = new Map();
    targetNodes.map(item => {
      treeNodeMap.set(item.key, nodeMap.get(item.key));
    });

    //第二步
    if (_checked === true) {//节点选中状态
      //支持多选select，则勾选其下所有子节点或者勾选其所有上层父节点直到根节点
      if (cascadable) {
        //this.findAndAddParentNode(_node.props, nodeMap, treeNodeMap);
        this.findAndAddChildNode(_node.props, nodeMap, treeNodeMap);
      }
    } else {//节点失去选中状态
      this.findAndRemoveChildNode(_node.props, nodeMap, treeNodeMap);
    }


    //对Map进行遍历，把新增过所有上下级树节点的checked节点数据给treeData
    let treeNodeList = [];
    treeNodeMap.forEach((value, key, map) => {
      treeNodeList.push(value);
    });

    const treeDataKeys = treeNodeList.map(node => node[treeKey]);
    const treeDataTitles = treeNodeList.map(node => node[treeTitleKey]);
    const treeDataLevels = treeNodeList.map(node => node[treeLevelKey]);

    this.setState({
      checkedKeys: treeDataKeys
    });

    this.props.onChange && this.props.onChange(treeDataKeys, treeDataTitles, treeDataLevels, treeNodeList);
  };

  onSelect = (_selectedKeys, info) => {
    const { selectSyncToCheck } = this.props;

    this.onTreeSelected(info.selectedNodes);

    //如果需要将节点选择事件同步到节点check事件，主要是调用onChecked方法中的onChange事件
    if (selectSyncToCheck) {
      this.onChecked(info.selected, info.selectedNodes, info.node);
    }
  };

  onTreeSelected = (treeSelectedNodes) => {
    const { nodeMap } = this.state;
    const { treeKey } = this.props;

    //获取当前登录用户所属机构的PID
    const operaterOrgId = $$.getStore("user").org.id;

    //获取当前登录用户所属机构的level
    const operaterOrgLevel = $$.getStore("user").org.level;

    let isPackage = $$.getStore("isPackage");
    if (isPackage === "undefined") {
      isPackage = false;
    }

    //获取当前选中的node
    let _selectedNodes = [];

    //给当前选中节点构造父节点，用于组织机构节点的编辑
    let _selectedParentNodes = [];

    const _selectedKeys = treeSelectedNodes.map(node => {
      _selectedNodes.push(nodeMap.get(node.key));
      _selectedParentNodes.push(nodeMap.get(node.props.pid));
      return node[treeKey];
    });

    let _canDelGroup = false;
    if (_selectedKeys.length > 0) {
      _canDelGroup = true;

      for (let i = 0; i < _selectedKeys.length; i++) {
        //打包版 如果选择的机构包含System，则不能删除
        //云版   如果选择的机构包含System，默认二级机构，默认三级机构，则不能删除
        if(isPackage){
          if(_selectedKeys[i] === "1"){
            _canDelGroup = false;
            break;
          }          
        }else{
          if (_selectedKeys[i] === "1" || _selectedKeys[i] === "2" || _selectedKeys[i] === "3") {
            _canDelGroup = false;
            break;
          }
        }

        //如果选择的组织机构不是叶子节点，则不能删除
        if (nodeMap.get(_selectedKeys[i]).children) {
          _canDelGroup = false;
          break;
        }

        //如果选择的组织机构包含当前操作用户的所属机构，则不能删除
        if (operaterOrgId === _selectedKeys[i]) {
          _canDelGroup = false;
          break;
        }
      }
    }

    let _canEditGroup = false;
    //打包版 选择机构只能一个，并且不是当前用户机构，不是System
    //云版   选择机构只能一个，并且不是当前用户机构，不是System，不是默认二级机构，不是默认三级机构
    if(isPackage){
      if (_selectedKeys.length === 1 && _selectedKeys[0] !== operaterOrgId && _selectedKeys[0] !== "1") {
        _canEditGroup = true;
      }
    }else{
      if (_selectedKeys.length === 1 && _selectedKeys[0] !== operaterOrgId && _selectedKeys[0] !== "1" && _selectedKeys[0] !== "2" && _selectedKeys[0] !== "3") {
        _canEditGroup = true;
      }
    }

    let _canAddGroup = false;
    //打包版 组织机构，可新建N级机构
    //云版   组织机构，如果是二级机构用户，只能新建三级机构，非二级机构用户可新建N级机构    
    if(isPackage){
      if (_selectedKeys.length === 1) {
        _canAddGroup = true;
      }
    }else{    
      if (operaterOrgLevel === '2') {
        if (_selectedKeys[0] === operaterOrgId) {
          _canAddGroup = true;
        }
      } else if (_selectedKeys.length === 1) {
        _canAddGroup = true;
      }
    }

    this.setState({
      canEditOrg: _canEditGroup,
      canDelOrg: _canDelGroup,
      canAddOrg: _canAddGroup,
      selectedKeys: _selectedKeys,
      selectedNodes: _selectedNodes,
      selectedParentNodes: _selectedParentNodes
    });
  };



  /**
   * 搜索结果渲染展示方法
   */
  renderSearchItem = searchList =>
    searchList.map((item, index) => (
      <li
        className="list-comp-item"
        title={item[this.props.treeTitleKey]}
        key={item[this.props.treeKey]}
        onClick={() => this.handleSelect(item)}
      >
        <span className="list-comp-item-body">
          {item[this.props.treeTitleKey]}
        </span>
      </li>
    ));

  /**
   * 搜索结果选择节点事件
   */
  handleSelect = selectedItem => {
    let _checkedNodes = [];

    _checkedNodes.push({ key: selectedItem.key, props: selectedItem });

    let node = {
      props: selectedItem
    };

    //点选树的搜索结果，选中对应节点
    let info = {selected: true, selectedNodes: _checkedNodes, node: node};
    this.onSelect([selectedItem.key], info);

    let expandedKeys = [];
    this.selectAllParentKeyArr(selectedItem, expandedKeys);

    this.setState({
      defaultExpandedKeys: expandedKeys,
      defaultExpandAll: false,
      flag: false
    }, () => {
      this.setState({
        defaultExpandedKeys: expandedKeys,
        defaultExpandAll: false,
        flag: true
      });
    });

    //关闭搜索结果
    this.handleClear();
  };

  selectAllParentKeyArr = (selectedItem, expandedKeys) => {
    expandedKeys.push(selectedItem[this.props.treeKey]);

    //如果最后一个元素不是根节点的Key则遍历查找
    selectedItem = this.flatTreeData.filter(
      item => item[this.props.treeKey] === selectedItem.pid
    )[0]

    if (selectedItem) {
      this.selectAllParentKeyArr(selectedItem, expandedKeys);
    }
  }

  /**
   * 渲染树方法
   */
  renderTreeNodes = data => {
    const { treeKey, treeTitleKey } = this.props;
    return data.map(item => {
      let spanElement1 = React.createElement('span', { key: item[treeKey] + '-span1', className: 'span1'}, item[treeTitleKey]);
      let spanElement2 = React.createElement('span', { key: item[treeKey] + '-span2', className: 'span2'}, " ( ");
      let spanElement3 = React.createElement('span', { key: item[treeKey] + '-span3', className: 'span3'}, item.onlineClientCount);
      let spanElement4 = React.createElement('span', { key: item[treeKey] + '-span4', className: 'span4'}, " / " + item.totalClientCount + " )");
      let spanElement5 = React.createElement('span', { key: item[treeKey] + '-span5', className: 'ant-tree-node-title'}, [spanElement1, spanElement2, spanElement3, spanElement4]);

      const treeProps = {
        ...item,
        key: item[treeKey],
        title: spanElement5,
        dataRef: item
      };

      if (item.children) {
        return (
          <Tree.TreeNode {...treeProps}>
            {this.renderTreeNodes(item.children)}
          </Tree.TreeNode>
        );
      }
      return <Tree.TreeNode {...treeProps} />;
    });
  };

  showFormModal = (selfRecord, parentRecord) => () => {
    this.setState({
      selfRecord,
      parentRecord,
      formModalVisible: true
    });
  }

  showDeleteOrgModal = () => () => {
    let _selectedNodes = this.state.selectedNodes;

    if (!_selectedNodes) return;

    if ($$.isArray(_selectedNodes) && !_selectedNodes.length) return;

    Modal.confirm({
      className: 'custom-modal',
      title:window.language['org.deleteOrgTitle'],
      okText:window.language['common.ok'],
      cancelText:window.language['common.cancel'],
      content:window.language['org.deleteOrgTip'],
      onOk: () => {
        this.handleDelete($$.isArray(_selectedNodes) ? _selectedNodes : [_selectedNodes]);
      },
      onCancel() {}
    });
  }

  /**
   * 等同于
   * 
   * handleDelete = function(selectedNodes) {
   *     ...
   * }
   */
  handleDelete = (selectedNodes) => {
    const { selectedKeys } = this.state;

    //获取要删除机构名
    let selectedOrgNames = [];

    selectedNodes.map(node => {
      selectedOrgNames.push(node.title);
    });

    //获取表单输入值
    let postParams = { ids: selectedKeys.join(","), names: selectedOrgNames.join(",") };

    delOrg(postParams).then(
      ({ code, msg }) => {
        if (code === "200") {
          this.setState({
            selfRecord: null,
            parentRecord: null,
            canDelOrg: false,
            canAddOrg: false,
            canEditOrg: false,
            selectedNodes: [],//已点选节点数组
            selectedKeys: [],//已点选节点key数组
            selectedParentNodes: []//已点选节点对应的父节点数组（和selectedNodes是一一对应的），用于节点的编辑
          });

          //删除 组织机构成功
          this.doSearch();

          //回调函数，方便查询终端
          this.props.callback && this.props.callback(true);

          notice.success(window.language['conmmon.del.success']);
        } else {
          notice.error(window.language['responseCode.' + code]);
        }
      }
    ).catch((error) => {
      notice.error(window.language['conmmon.del.error']);
    });
  }

  render() {
    const {
      prefixCls,
      checkable,
      multiple,
      showSearch,
      showToolbar,
      notFoundContent,
      searchPlaceholder,
      className,
      loadData,
      loading
    } = this.props;

    const { filter, canDelOrg, canAddOrg, canEditOrg, checkedKeys, selfRecord, parentRecord,
      defaultExpandedKeys, selectedNodes, selectedKeys, selectedParentNodes, sourceNodes,
      searchList, formModalVisible, authCodes, flag, defaultExpandAll } = this.state;

    const cls = classNames({
      [className]: !!className,
      [prefixCls]: true
    });

    const showTree = (
      <Tree
        checkable={checkable}
        showLine
        multiple={multiple}
        checkStrictly={true}//checkable状态下节点选择完全受控（父子节点选中状态不再关联）
        defaultExpandedKeys={defaultExpandedKeys}
        defaultExpandAll={defaultExpandAll}
        onCheck={this.onCheck}
        onSelect={this.onSelect}
        loadData={loadData}
        selectedKeys={selectedKeys}
        checkedKeys={checkedKeys}
      >
        {this.renderTreeNodes(sourceNodes)}
      </Tree>
    );

    /** 新增， 编辑 */
    const formModalProps = {
      loading,
      selfRecord,
      parentRecord,
      visible: formModalVisible,
      modalOpts: {
        width: 485
      },
      onCancel: () => {
        this.setState({
          selfRecord: null,
          parentRecord: null,
          formModalVisible: false
        })
      },
      onSubmit: (values, selfRecord, parentRecord) => {
        //获取表单输入值
        let postParams = {
          id: values.id, pid: values.parentId, level: values.level, name: values.name, remark: values.remark
        };

        if (selfRecord) {
          updateOrg(postParams).then(
            ({ code, msg }) => {
              if (code === "200") {
                this.setState({
                  selfRecord: null,
                  parentRecord: null,
                  canDelOrg: false,
                  canAddOrg: false,
                  canEditOrg: false,
                  selectedNodes: [],//已点选节点数组
                  selectedKeys: [],//已点选节点key数组
                  selectedParentNodes: [],//已点选节点对应的父节点数组（和selectedNodes是一一对应的），用于节点的编辑
                  formModalVisible: false
                });

                //编辑 组织机构成功
                this.doSearch();

                //回调函数，方便查询终端
                this.props.callback && this.props.callback(false);

                notice.success(window.language['conmmon.update.success']);
              } else {
                notice.error(window.language['responseCode.' + code]);
              }
            }
          ).catch((error) => {
            notice.error(window.language['conmmon.submit.error']);
          });

        } else {
          addOrg(postParams).then(
            ({ code, msg }) => {
              if (code === "200") {
                this.setState({
                  selfRecord: null,
                  parentRecord: null,
                  canDelOrg: false,
                  canAddOrg: false,
                  canEditOrg: false,
                  selectedNodes: [],//已点选节点数组
                  selectedKeys: [],//已点选节点key数组
                  selectedParentNodes: [],//已点选节点对应的父节点数组（和selectedNodes是一一对应的），用于节点的编辑
                  formModalVisible: false
                });

                //新增 组织机构成功
                this.doSearch();

                //回调函数，方便查询终端
                this.props.callback && this.props.callback(false);

                notice.success(window.language['conmmon.add.success']);
              } else {
                notice.error(window.language['responseCode.' + code]);
              }
            }
          ).catch((error) => {
            notice.error(window.language['conmmon.submit.error']);
          });

        }
      }
    };

    return (
      <div className={prefixCls}>
        <div
          className={
            showSearch
              ? `${prefixCls}-body ${prefixCls}-body-with-search`
              : `${prefixCls}-body`
          }
        >
          {showToolbar && (authCodes["SYSTEM.ORGANIZATION.ADD"] || authCodes["SYSTEM.ORGANIZATION.EDIT"] || authCodes["SYSTEM.ORGANIZATION.DELETE"]) ? (
            <div className={`${prefixCls}-body-toolbar`}>
              <div>
                {authCodes["SYSTEM.ORGANIZATION.ADD"] ? (
                  <span>
                    <Button disabled={!canAddOrg} cdmsicon="add-o" type="primary" onClick={this.showFormModal(null, selectedNodes[0])}>{window.language['common.add2']}</Button>
                  </span>
                ) : null}
                {authCodes["SYSTEM.ORGANIZATION.EDIT"] ? (
                  <span>
                    <Button disabled={!canEditOrg} cdmsicon="edit-o" onClick={this.showFormModal(selectedNodes[0], selectedParentNodes[0])}>{window.language['common.update']}</Button>
                  </span>
                ) : null}
                {authCodes["SYSTEM.ORGANIZATION.DELETE"] ? (
                  <span>
                    <Button disabled={!canDelOrg} cdmsicon="delete-o" onClick={this.showDeleteOrgModal()}>{window.language['common.del']}</Button>
                  </span>
                ) : null}
              </div>
            </div>
          ) : null}
          {showSearch ? (
            <div className={`${prefixCls}-body-search-wrapper`}>
              <Search
                prefixCls={`${prefixCls}-search`}
                onChange={this.handleFilter}
                handleClear={this.handleClear}
                placeholder={searchPlaceholder || window.language['common.inputSearchContent']}
              />
            </div>
          ) : null}
          <div className={`${prefixCls}-body-content tree-content`}>
            {filter ? (
              <ul className="tree-filter-result">
                {this.renderSearchItem(searchList)}
              </ul>
            ) : null}
            {sourceNodes.length && flag ? (
              showTree
            ) : (
                <div className={`${prefixCls}-body-content-not-found`}>
                  {loading ? (
                    <Spin spinning={loading} />
                  ) : (
                      notFoundContent || window.language['common.ListIsEmpty']
                    )}
                </div>
              )}
          </div>
        </div>
        {formModalVisible === true ? (
          <OrgFormModal {...formModalProps} />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/System/Org/components/OrgTree.js